module.exports = __webpack_public_path__ + "static/media/vasco.92567792.svg";